var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhiskey = function SvgWhiskey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F9F6"
    },
    d: "M403.581,512h-87.643c-5.892,0-10.808-4.501-11.325-10.371l-11.658-132.251 c-0.373-4.234,2.963-7.877,7.213-7.877h119.183c4.25,0,7.586,3.643,7.213,7.877l-11.658,132.251 C414.388,507.499,409.473,512,403.581,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6E5E2"
    },
    d: "M419.351,361.501h-48.888L357.196,512h46.384c5.892,0,10.808-4.501,11.325-10.371l11.658-132.251 C426.937,365.144,423.601,361.501,419.351,361.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5F9F6"
    },
    d: "M196.648,69.706V32.333h-58.984v37.373c0,29.644-13.089,57.776-35.764,76.87l-9.745,8.205 c-4.276,3.601-6.745,8.906-6.745,14.497V492.66c0,10.681,8.659,19.34,19.34,19.34h124.811c10.681,0,19.34-8.659,19.34-19.34V169.279 c0-5.591-2.468-10.896-6.745-14.497l-9.745-8.205C209.736,127.482,196.648,99.35,196.648,69.706z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD9727"
    },
    d: "M296.229,406.52l8.384,95.11c0.517,5.869,5.433,10.371,11.325,10.371h87.643 c5.892,0,10.808-4.501,11.325-10.371l8.384-95.11L296.229,406.52L296.229,406.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD9727"
    },
    d: "M101.899,146.576l-9.745,8.205c-4.276,3.601-6.745,8.906-6.745,14.497V492.66 c0,10.681,8.659,19.34,19.34,19.34h124.812c10.681,0,19.34-8.659,19.34-19.34V169.279c0-5.591-2.468-10.896-6.745-14.497 l-9.745-8.205c-14.293-12.035-24.772-27.663-30.57-44.995h-69.373C126.671,118.913,116.192,134.541,101.899,146.576z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E57F23"
    },
    d: "M248.901,492.66V169.279c0-2.096-0.347-4.153-1.006-6.094c-0.22-0.647-0.474-1.282-0.762-1.9 c-0.576-1.238-1.285-2.413-2.118-3.504s-1.789-2.098-2.858-2.998l-9.745-8.205c-0.815-0.687-1.615-1.388-2.405-2.098 c-0.243-0.219-0.482-0.441-0.723-0.662c-0.555-0.508-1.104-1.02-1.646-1.539c-0.258-0.247-0.515-0.495-0.77-0.744 c-0.555-0.543-1.102-1.093-1.643-1.647c-0.202-0.207-0.407-0.411-0.606-0.62c-0.739-0.77-1.467-1.549-2.179-2.341 c-0.042-0.047-0.083-0.096-0.126-0.143c-0.666-0.743-1.318-1.496-1.96-2.257c-0.186-0.221-0.369-0.444-0.553-0.667 c-0.508-0.612-1.008-1.23-1.501-1.853c-0.185-0.234-0.369-0.467-0.551-0.702c-0.538-0.694-1.066-1.394-1.585-2.101 c-0.106-0.144-0.215-0.287-0.321-0.432c-0.646-0.889-1.278-1.787-1.893-2.695c-0.012-0.018-0.024-0.037-0.036-0.055 c-0.584-0.863-1.151-1.737-1.708-2.617c-0.117-0.185-0.232-0.372-0.347-0.558c-0.466-0.748-0.922-1.502-1.368-2.261 c-0.108-0.184-0.217-0.368-0.324-0.553c-0.52-0.899-1.029-1.804-1.521-2.719c-0.009-0.016-0.018-0.032-0.027-0.048 c-1.046-1.948-2.025-3.931-2.94-5.943c-0.067-0.147-0.132-0.295-0.199-0.442c-0.393-0.875-0.774-1.755-1.141-2.641 c-0.054-0.129-0.108-0.258-0.162-0.387c-0.846-2.062-1.626-4.151-2.334-6.267h-45.758c1.061,8.728,3.213,17.302,6.538,25.47 c3.077,7.557,7.213,15.012,12.573,19.526l2.748,2.314c8.713,7.336,13.742,18.146,13.742,29.536V512h37.878 c2.003,0,3.934-0.304,5.751-0.87C243.185,508.682,248.901,501.338,248.901,492.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A4256"
    },
    d: "M197.972,53.854h-61.634c-3.078,0-5.574-2.496-5.574-5.574V5.574c0-3.078,2.496-5.574,5.574-5.574 h61.634c3.078,0,5.574,2.496,5.574,5.574V48.28C203.546,51.359,201.051,53.854,197.972,53.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#352F3F"
    },
    d: "M197.972,0h-51.517v53.854h51.517c3.078,0,5.574-2.496,5.574-5.574V5.574 C203.546,2.496,201.051,0,197.972,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4A4256"
    },
    points: "85.41,325.686 248.901,401.361 248.901,287.895 85.41,212.22 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#352F3F"
    },
    points: "248.901,401.361 248.901,287.895 191.683,261.411 191.683,374.877 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDC74F"
    },
    points: "248.901,317.11 248.901,287.895 85.41,212.22 85.41,240.628 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5A535"
    },
    points: "248.901,317.11 248.901,287.895 191.683,261.411 191.683,290.343 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDC74F"
    },
    points: "85.41,298.533 85.41,325.686 248.901,401.361 248.901,375.015 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5A535"
    },
    points: "248.901,401.361 248.901,375.015 191.683,348.248 191.683,374.877 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M213.548,452.1h-92.786c-4.27,0-7.732-3.462-7.732-7.732s3.462-7.732,7.732-7.732h92.786 c4.27,0,7.732,3.462,7.732,7.732C221.281,448.638,217.819,452.1,213.548,452.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9EAEB"
    },
    d: "M213.548,479.447h-92.786c-4.27,0-7.732-3.462-7.732-7.732s3.462-7.732,7.732-7.732h92.786 c4.27,0,7.732,3.462,7.732,7.732C221.281,475.985,217.819,479.447,213.548,479.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M213.548,479.447h-92.786c-4.27,0-7.732-3.462-7.732-7.732s3.462-7.732,7.732-7.732h92.786 c4.27,0,7.732,3.462,7.732,7.732C221.281,475.985,217.819,479.447,213.548,479.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E57F23"
    },
    d: "M366.495,406.52L357.196,512h46.384c5.892,0,10.808-4.501,11.325-10.371l8.384-95.11h-56.794V406.52z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6E5E2"
    },
    d: "M196.648,53.854h-41.377l0.028,34.849c0.003,4.31,0.266,8.612,0.784,12.878h45.758 c-3.401-10.165-5.194-20.916-5.194-31.875V53.854H196.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7E0DC"
    },
    d: "M408.796,485.566h-98.073c-2.909,0-5.604-0.983-7.759-2.643l1.649,18.706 c0.517,5.869,5.433,10.371,11.325,10.371h87.643c5.892,0,10.808-4.501,11.325-10.371l1.649-18.706 C414.4,484.583,411.705,485.566,408.796,485.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBD1CF"
    },
    d: "M408.796,485.566h-49.27L357.196,512h46.384c3.314,0,6.32-1.424,8.407-3.715 c1.624-1.782,2.692-4.088,2.918-6.656l1.649-18.706C414.4,484.583,411.705,485.566,408.796,485.566z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiskey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whiskey.73ed425c.svg";
export { ForwardRef as ReactComponent };